module.exports = __webpack_public_path__ + "static/img/empty.f93905f1.png";